export const SET_REGIMENS = 'setRegimens';